import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=4e6c4026&scoped=true&"
import script from "./PostComment.vue?vue&type=script&lang=js&"
export * from "./PostComment.vue?vue&type=script&lang=js&"
import style0 from "./PostComment.vue?vue&type=style&index=0&id=4e6c4026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c4026",
  null
  
)

export default component.exports